import MileageSettingsAddParams from "../../../../common/services/mileage/settings/add/mileage-settings-add-params";
import MileageSettingsUpdateParams from "../../../../common/services/mileage/settings/update/mileage-settings-update-params";
import MileageNumberCreationModel from "../../../../common/types/mileage-number-creation-model";
import MileageSettingsFormData from "../form/types/mileage-settings-form-data";
import MileageSettingsMileageNumberCreationModel from "../types/mileage-settings-mileage-number-creation-model";

const createCreationModel = (
  model: MileageSettingsMileageNumberCreationModel,
): MileageNumberCreationModel => {
  switch (model) {
    case MileageSettingsMileageNumberCreationModel.AUTO:
      return MileageNumberCreationModel.AUTO;
    case MileageSettingsMileageNumberCreationModel.DICT:
      return MileageNumberCreationModel.DICT;
    case MileageSettingsMileageNumberCreationModel.MANUAL:
      return MileageNumberCreationModel.MANUAL;
  }
};

const createAddParams = (
  companyUuid: string,
  formData: MileageSettingsFormData,
): MileageSettingsAddParams => {
  return {
    companyUuid: companyUuid,
    isCardNumberRequired: formData.isCardNumberRequired,
    isMileageNumberRequired: formData.isMileageNumberRequired,
    mileageNumberCreationModel: createCreationModel(
      formData.mileageNumberCreationModel,
    ),
  };
};

const createUpdateParams = (
  companyUuid: string,
  formData: MileageSettingsFormData,
): MileageSettingsUpdateParams => {
  return {
    cargoCompanyUuid: companyUuid,
    isCardNumberRequired: formData.isCardNumberRequired,
    isMileageNumberRequired: formData.isMileageNumberRequired,
    mileageNumberCreationModel: createCreationModel(
      formData.mileageNumberCreationModel,
    ),
  };
};

const mileageSettingsParamsFactory = {
  createAddParams,
  createUpdateParams,
};

export default mileageSettingsParamsFactory;
